import React from 'react';
import LoaderRing from 'Shared/LoaderRing';

const Loader = () => (
  <div
    className="bg-base-main opacity-80 fixed inset-0 flex justify-center items-center"
    style={{
      zIndex: 999999,
    }}
  >
    <LoaderRing sizeContainer="40px" sizeRing="28px" border="4px" />
  </div>
);

export default Loader;
